'use strict';

(function() {
	angular.module('onboarding.internaladmin')
		.directive('cobAdminContractList', cobAdminContractList);

	cobAdminContractList.$inject = ['subjectObserverMessagesService', 'observerService', 'internalAdminService'];

	var subjectObserverMessagesService, observerService, internalAdminService;

	function cobAdminContractList(_subjectObserverMessagesService_, _observerService_, _internalAdminService_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		internalAdminService = _internalAdminService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/internaladmin/cobAdminContractList.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			var subjectMessages = subjectObserverMessagesService.getSubjectMessages(),
				observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.ajaxIsRunning = false;
			scope.contracts = [];
			scope.totalRows = 0;
			scope.sortType = 'companyName';
			scope.sortReverse = true;
			scope.templateClicked = templateClicked;
			scope.saveTemplateId = saveTemplateId;
			scope.scope = scope;

			document.title = 'Admin - Contracts';
			getContracts();
		}

		function getContracts() {
			if (scope.ajaxIsRunning) {
				return;
			}

			scope.ajaxIsRunning = true;
			setTimeout(function() {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			},
			1);

			internalAdminService.getAssureSignContracts()
				.then(function(response) {

					var length = response.data.contracts.length;
					for (var i = 0; i < length; i++) {
						scope.contracts.push(response.data.contracts[i]);
					}
				})
				.catch(function(e) {
					console.log(e);
				})
				.finally(function() {
					scope.ajaxIsRunning = false;
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			return;
		}

		function saveTemplateId(contract) {
			if (contract.oldValue !== contract.templateId || contract.oldValue !== undefined) {
				if (contract.templateId !== '' && contract.templateId !== null) {
					internalAdminService
						.updateContractTemplateId(contract.brokerId,
							contract.contractId,
							contract.templateId,
							contract.contractName)
						.catch(function(res) {
							var modelErrors = res.data.modelState;
							var errors = [];
							for (var key in modelErrors) {
								for (var i = 0; i < modelErrors[key].length; i++) {
									errors.push(modelErrors[key][i]);
								}
							}

							console.log(errors);

						});
					contract.editingTemplateId = false;
				} else {
					contract.templateId = contract.oldValue;

					scope.$apply(function() {
						contract.editingTemplateId = false;
					});

					return;
				}
			}
		}

		function templateClicked($event, contract) {
			$event.stopPropagation();
			if (contract.editingTemplateId !== true) {
				contract.oldValue = contract.templateId;
				contract.editingTemplateId = true;
			}
		}
	}

})();
